export const Categories = [
    {category: 'Private' },
    {category: 'Business' },
    {category: 'Other' }
];